export default {
    DEFAULT: 0,
    UPDATED_AT_DESC: 1,
    DESCRIPCION_ASC: 2,
    DESCRIPCION_DESC: 3,
    PVP_ASC: 4,
    PVP_DESC: 5,
};
